import {
    SET_TRANLSLATION,
} from '../actions';
import english from "../../translations/en.json";

const INIT_STATE = {
    currentTranslation: "en",
    translation: { ...english }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SET_TRANLSLATION: {
            return {
                ...state,
                ...action.payload
            };
        }

        default:
            return state
    }
};
